module.exports = __webpack_public_path__ + "static/media/avatar.81f7cbf0.png";